const initialState = {
    requestingFetchNaturalPersons: false,
    successfulFetchNaturalPersons: false,
    errorFetchNaturalPersons: false,
    naturalPersons: {},
    requestingCreateNaturalPerson: false,
    successfulCreateNaturalPerson: false,
    errorsCreateNaturalPerson: false,
    naturalPerson: null,
    requestingSignatureNaturalPerson: false,
    successfulSignatureNaturalPerson: false,
    errorsSignatureNaturalPerson: false,
    naturalPersonSignature: null,
    requestingReadNaturalPerson: false,
    successfulReadNaturalPerson: false,
    errorsReadNaturalPerson: false,
    rowEdited: null,
    requestingDeleteNaturalPerson: false,
    successfulDeleteNaturalPerson: false,
    errorsDeleteNaturalPerson: false,
    rowDeleted: null,
    requestingUpdateNaturalPerson: false,
    successfulUpdateNaturalPerson: false,
    errorsUpdateNaturalPerson: false,
    rowUpdated: null,
  };
  
  const naturalPersonReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_NATURAL_PERSONS_REQUESTING":
        return {
          ...state,
          requestingFetchNaturalPersons: true,
          successfulFetchNaturalPersons: false,
          errorsFetchNaturalPersons: false,
        };
      case "FETCH_NATURAL_PERSON_SUCCESS":
        return {
          ...state,
          errorFetchNaturalPersons: false,
          requestingFetchNaturalPersons: false,
          successfulFetchNaturalPersons: true,
          naturalPersons: action.value,
        };
      case "FETCH_NATURAL_PERSON_ERROR":
        return {
          ...state,
          errorFetchNaturalPersons: true,
          requestingFetchNaturalPersons: false,
          successfulFetchNaturalPersons: false,
        };
      case "CREATE_NATURAL_PERSON_REQUESTING":
        return {
          ...state,
          requestingCreateNaturalPerson: true,
          successfulCreateNaturalPerson: false,
          errorsCreateNaturalPerson: false,
        };
      case "CREATE_NATURAL_PERSON_SUCCESS":
        return {
          ...state,
          errorsCreateNaturalPerson: false,
          requestingCreateNaturalPerson: false,
          successfulCreateNaturalPerson: true,
          naturalPerson: action.value,
        };
      case "CREATE_NATURAL_PERSON_RESET":
        return {
          ...state,
          errorsCreateNaturalPerson: false,
          requestingCreateNaturalPerson: false,
          successfulCreateNaturalPerson: false,
          naturalPerson: null,
        };
      case "CREATE_NATURAL_PERSON_ERROR":
        return {
          ...state,
          errorsCreateNaturalPerson: true,
          requestingCreateNaturalPerson: false,
          successfulCreateNaturalPerson: false,
        };
      case "SIGNATURE_NATURAL_PERSON_REQUESTING":
        return {
          ...state,
          requestingSignatureNaturalPerson: true,
          successfulSignatureNaturalPerson: false,
          errorsSignatureNaturalPerson: false,
        };
      case "SIGNATURE_NATURAL_PERSON_SUCCESS":
        return {
          ...state,
          errorsSignatureNaturalPerson: false,
          requestingSignatureNaturalPerson: false,
          successfulSignatureNaturalPerson: true,
          naturalPersonSignature: action.value,
        };
      case "SIGNATURE_NATURAL_PERSON_RESET":
        return {
          ...state,
          errorsSignatureNaturalPerson: false,
          requestingSignatureNaturalPerson: false,
          successfulSignatureNaturalPerson: false,
          naturalPersonSignature: null,
        };
      case "SIGNATURE_NATURAL_PERSON_ERROR":
        return {
          ...state,
          errorsSignatureNaturalPerson: true,
          requestingSignatureNaturalPerson: false,
          successfulSignatureNaturalPerson: false,
        };
      case "READ_NATURAL_PERSON_REQUESTING":
        return {
          ...state,
          requestingReadNaturalPerson: true,
          successfulReadNaturalPerson: false,
          errorsReadNaturalPerson: false,
        };
      case "READ_NATURAL_PERSON_SUCCESS":
        return {
          ...state,
          errorsReadNaturalPerson: false,
          requestingReadNaturalPerson: false,
          successfulReadNaturalPerson: true,
          rowEdited: action.value,
        };
      case "READ_NATURAL_PERSON_ERROR":
        return {
          ...state,
          errorsReadNaturalPerson: true,
          requestingReadNaturalPerson: false,
          successfulReadNaturalPerson: false,
        };
      case "DELETE_NATURAL_PERSON_REQUESTING":
        return {
          ...state,
          requestingDeleteNaturalPerson: true,
          successfulDeleteNaturalPerson: false,
          errorsDeleteNaturalPerson: false,
        };
      case "DELETE_NATURAL_PERSON_SUCCESS":
        return {
          ...state,
          errorsDeleteNaturalPerson: false,
          requestingDeleteNaturalPerson: false,
          successfulDeleteNaturalPerson: true,
          rowDeleted: action.value,
        };
      case "DELETE_NATURAL_PERSON_ERROR":
        return {
          ...state,
          errorsDeleteNaturalPerson: true,
          requestingDeleteNaturalPerson: false,
          successfulDeleteNaturalPerson: false,
        };
      case "UPDATE_NATURAL_PERSON_REQUESTING":
        return {
          ...state,
          requestingUpdateNaturalPerson: true,
          successfulUpdateNaturalPerson: false,
          errorsUpdateNaturalPerson: false,
        };
      case "UPDATE_NATURAL_PERSON_SUCCESS":
        return {
          ...state,
          errorsUpdateNaturalPerson: false,
          requestingUpdateNaturalPerson: false,
          successfulUpdateNaturalPerson: true,
          rowUpdated: action.value,
        };
      case "UPDATE_NATURAL_PERSON_ERROR":
        return {
          ...state,
          errorsUpdateNaturalPerson: true,
          requestingUpdateNaturalPerson: false,
          successfulUpdateNaturalPerson: false,
        };
      case "RESET_NATURAL_PERSON_FORM":
        return {
          ...state,
          requestingCreateNaturalPerson: false,
          successfulCreateNaturalPerson: false,
          errorsCreateNaturalPerson: false,
          naturalPerson: null,
          requestingReadNaturalPerson: false,
          successfulReadNaturalPerson: false,
          errorsReadNaturalPerson: false,
          rowEdited: null,
          requestingDeleteNaturalPerson: false,
          successfulDeleteNaturalPerson: false,
          errorsDeleteNaturalPerson: false,
          rowDeleted: null,
          requestingUpdateNaturalPerson: false,
          successfulUpdateNaturalPerson: false,
          errorsUpdateNaturalPerson: false,
          rowUpdated: null,
          requestingUpdateNaturalPerson: false,
          successfulUpdateNaturalPerson: false,
          errorsUpdateNaturalPerson: false,
          rowUpdated: null,
        };
      case "RESET":
        return initialState;
      default:
        return state;
    }
  };
  
  export default naturalPersonReducer;
  